import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { PROFILE_MODES } from "../../services/constants";
import Form from "../../components/pages/register/services/Form";

const Services = () => {
    const formRef = useRef(null);

    const { mode } = useSelector((state) => state.personalInfo);

    const theme = useTheme();
    const isMdScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box className="page">
            <Grid container justifyContent={"center"}>
                <Grid
                    container
                    item
                    direction={"row"}
                    rowSpacing={5}
                    columnSpacing={isMdScreen ? 0 : 10}
                    md={9}
                    sm={12}
                    xs={12}
                >
                    <Grid item xs={12} ref={formRef}>
                        <Form />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Services;
